// import { message } from 'antd';

// const utils = {
//     showSucesso: (msg) => {
//       return message.success(msg);
//     },
  
//     showWarning: (msg) => {
//       return message.warning(msg);
//     },

//     showErro: (msg) => {
//         return message.error (msg);
//       }
//   }
  
import { notification } from 'antd';

const utils = { 
    showSucesso: (msg) => {
      return notification['success']({ message: msg });
    },
  
    showWarning: (msg) => {
      return notification['warning']({ message: msg });
    },

    showErro: (msg) => {
        return notification['error']({ message: msg });
      }
  }
    

export default utils;